const element = document.querySelector('.m-mainnav');
const htmlElement = document.querySelector('html');
const aButtonHamburgerElement = document.querySelector('.a-button-hamburger');

console.log('Button element:', aButtonHamburgerElement);
console.log('Nav element:', element);

if (aButtonHamburgerElement) {
	console.log('Button computed style:', window.getComputedStyle(aButtonHamburgerElement));
	console.log('Button rect:', aButtonHamburgerElement.getBoundingClientRect());
}

if (aButtonHamburgerElement && element) {
	function showNav() {
		console.log('showNav called');
		htmlElement.scroll({
			top: 0,
			behavior: 'smooth',
		});
		htmlElement.setAttribute('data-no-scroll', 'true');
		element.setAttribute('data-open', 'true');
		aButtonHamburgerElement.classList.add('is-active');
	}

	function hideNav() {
		console.log('hideNav called');
		htmlElement.removeAttribute('data-no-scroll');
		element.removeAttribute('data-open');
		aButtonHamburgerElement.classList.remove('is-active');
	}

	aButtonHamburgerElement.addEventListener('click', (e) => {
		console.log('Button clicked!', e);
		if (element.hasAttribute('data-open')) {
			hideNav();
		} else {
			showNav();
		}
	});
	
	// Also add a pointer down event to debug
	aButtonHamburgerElement.addEventListener('pointerdown', () => {
		console.log('Pointer down on button');
	});
} else {
	console.error('Button or nav element not found');
}
